import {
    Box,
    BRANDS,
    Button,
    Flex,
    Heading,
    Paragraph,
    THEME_CONSTANTS,
    THEME_UTILITIES,
    useBrand
} from '@cof/plastic-components';
import ReasonsToQuote from '../../../components/ReasonsToQuote';
import { useAggregatorConsumerName } from '../../../utilities/aggregatorConsumerNameProvider';
import { isAggregatorConsumer, isHosted, isPartnerOrAggsEdit } from '../../../utilities/utils';
import { TermsAndConditionsContainer } from '../../../components/Stage/StyledComponents';
import TermsAndConditions from '../../../components/Stage/TermsAndConditions';
import PropTypes from 'prop-types';
import partners from '../../../partners';
import QuickcheckGuarantee from '../../../components/Stage/QuickcheckGuarantee';
import { SingleFormWrapper } from './SharedStyledComponents';
import config from '@cof/ukweb-config/lib/clientConfig';

const { useColor } = THEME_UTILITIES;

const QuickCheckButton = ({ handleQuickCheck }: any) => {
    const brand = useBrand();
    return (
        <Box mt="md" mb="sm">
            <Button
                data-qa-id="submit-button"
                style={{
                    backgroundColor:
                        brand === BRANDS.ASOS.toLowerCase() ? THEME_CONSTANTS.COLORS.ASOS.green650 : undefined
                }}
                onClick={handleQuickCheck}
                data-qm-allow
            >
                QuickCheck now
            </Button>
        </Box>
    );
};

QuickCheckButton.propTypes = {
    handleQuickCheck: PropTypes.func.isRequired
};

const ApplySection = ({ handleQuickCheck }: any) => {
    // @ts-expect-error TS2488: Type '' must have a '[Symbol.iterator]()' method that returns an iterator.
    const [aggregatorConsumerName] = useAggregatorConsumerName();
    const brand = useBrand();
    const isReasonsToQuote = isHosted(brand) && !isAggregatorConsumer(aggregatorConsumerName);
    const isPromoTnCs = [partners.VERY, partners.LITTLEWOODS].includes(brand);
    const isPartnerAggsEdit = isPartnerOrAggsEdit(brand, aggregatorConsumerName);

    const headingColor = useColor({
        ocean: 'ocean.blue800',
        ASOS: 'ASOS.grey850',
        fallback: 'capitalOne.blue750'
    });

    const showASOSPremierBanner = () => {
        return (
            config.get('features.asosPremierBanner') &&
            brand === partners.ASOS &&
            !isAggregatorConsumer(aggregatorConsumerName)
        );
    };

    return isReasonsToQuote ? (
        <ReasonsToQuote
            data-qm-allow
            nextButton={<QuickCheckButton handleQuickCheck={handleQuickCheck} data-qm-allow />}
            showASOSPremierBanner={showASOSPremierBanner()}
        />
    ) : (
        <SingleFormWrapper data-qm-allow>
            <Heading level="3" color={headingColor} textAlign={'left'} data-qm-allow>
                Now for a quick look at your credit history
            </Heading>
            <Paragraph data-qm-allow>
                This won&apos;t impact your credit score, and you&apos;ll be the only one who can see it on your credit
                report.
            </Paragraph>
            <Paragraph mt={'sm'} data-qm-allow>
                All we do is pass your info to credit reference agencies to do a pre-application check of your credit
                rating.
            </Paragraph>
            <TermsAndConditionsContainer data-qm-allow>
                {isPromoTnCs && (
                    <TermsAndConditions
                        modalPath="OfferText"
                        tAndcPath="OfferTAndC"
                        path="MoneyBackStatement"
                        id="offer-terms-and-conditions"
                        data-qm-allow
                    />
                )}
                <TermsAndConditions
                    modalSize="fullSize"
                    tAndcPath="TAndC"
                    path="Statement"
                    modalPath="Text"
                    id="terms-and-conditions"
                    data-qm-allow
                />
            </TermsAndConditionsContainer>
            <Flex justifyContent="center" data-qm-allow>
                <Flex display="inline-flex" width={['100%', null, 'auto']} flexDirection="column" data-qm-allow>
                    <QuickCheckButton handleQuickCheck={handleQuickCheck} data-qm-allow />
                </Flex>
            </Flex>
            {!isPartnerAggsEdit && <QuickcheckGuarantee data-qm-allow />}
        </SingleFormWrapper>
    );
};

ApplySection.propTypes = {
    handleQuickCheck: PropTypes.func.isRequired
};

export default ApplySection;
